import { useState } from "react";
import { errorMessage } from "../../../../../Utils/useRequest";
import { QuestionnaireProps, getQuestionnaire } from "../../service";
import { message, Modal } from "antd";
import { useHistory } from "react-router-dom";

export default function useHeaderData(questionnaireId: string) {
    const history = useHistory();
    const [headData, setHeadData] = useState<QuestionnaireProps | null>(null);
    const [stopStatus, setStopStatus] = useState<number | null | undefined>(
        5000
    ); //每5s检测问卷状态

    async function reloadHeadData() {
        try {
            let res = await getQuestionnaire(questionnaireId);
            setHeadData(res);
            // if(!data) {//为了解决通过url再次进入已打完没结束的题两种提示的问题，给试卷放在获取头部信息之后
            //     let data = await getPaper(questionnaireId);
            //     setData(data);
            // }
        } catch (e) {
            if ((e as any).response.data.data) {
                //返回512就没有data了会报错
                let info = (e as any).response.data.data;
                stateCase(info, e); //根据不同情况判断给出哪种'提示信息'
            } else {
                setStopStatus(null);
                message.error(errorMessage(e));
            }
        }
    }

    function stateCase(
        info: { paperStatusCode: string; studentSubmitPaper: boolean },
        e: any
    ) {
        setStopStatus(null); //停止重复的5s调用
        Modal.destroyAll(); //问卷已提前结束或者到时间了，如果提交弹窗没关闭就把弹窗都关闭了，之后给新的提示弹窗
        switch (info.paperStatusCode.toString()) {
            case "0": //试卷删除
                message.error("授课老师删除了本次问卷活动");
                break;
            case "1": //问卷未开始
                message.error(errorMessage(e));
                break;
            case "2": //问卷进行中
                // todo：提交过之后现在是这个状态，正常进行中不应该给错误信息
                if (info.studentSubmitPaper) {
                    Modal.info({
                        title: "提示：",
                        content:
                            "系统监测到您已提交问卷，您可在问卷活动列表查看活动",
                        onOk: () => {
                            history.goBack();
                        }
                    });
                }
                break;
            case "3": //问卷已结束
                if (info.studentSubmitPaper) {
                    //提交过
                    Modal.info({
                        title: "提示：",
                        content:
                            "活动已结束，由于系统监测到您已提交问卷，您可在问卷活动列表查看活动",
                        onOk: () => {
                            history.goBack();
                        }
                    });
                } else {
                    //未提交
                    Modal.info({
                        title: "提示：",
                        content:
                            "问卷活动已结束，由于您未能按时提交，系统不会将您的作答内容提交到教师侧，且会将本次问卷活动状态视为“待参与”。",
                        onOk: () => {
                            history.goBack();
                        }
                    });
                }

                break;
            case "4": //问卷被老师结束
                if (info.studentSubmitPaper) {
                    //提交过
                    Modal.info({
                        title: "提示：",
                        content:
                            "授课老师结束了本次问卷活动，由于系统监测到您已提交问卷，您可在问卷活动列表查看活动",
                        onOk: () => {
                            history.goBack();
                        }
                    });
                } else {
                    //未提交
                    Modal.info({
                        title: "提示：",
                        content:
                            "授课老师结束了本次问卷活动，由于您尚未提交问卷，系统不会将您的作答内容提交到教师侧，且会将本次问卷活动状态视为“待参与”。",
                        onOk: () => {
                            history.goBack();
                        }
                    });
                }
                break;
            default:
                message.error(errorMessage(e));
                break;
        }
    }

    return [headData, stopStatus, reloadHeadData] as [
        QuestionnaireProps,
        number | null | undefined,
        typeof reloadHeadData
    ];
}
